/**
 * German translations
 */

export default {
  GitHub: 'GitHub',
  'Trending repos': 'Beliebte Repositorys',
  'Copilot for business': 'GitHub Copilot Business',
  'Resource center': 'Ressourcencenter',
  'Enterprise-grade code security': 'Unternehmenstaugliche Codesicherheit',
  'Your source for the latest features, improvements, and fixes across GitHub products, all in one place.':
    'Die neuesten Funktionen, Verbesserungen und Fehlerbehebungen für GitHub-Produkte – alles an einem Ort.',
  'The event for developers, by developers — talks, workshops, and what’s next for GitHub.':
    'Das Event von Entwickler:innen für Entwickler:innen – Vorträge, Workshops und ein Ausblick auf die Zukunft von GitHub.',
  'Repository hosting, code review, and collaboration': 'Repository-Hosting, Codeüberprüfung und Zusammenarbeit',
  'Build & Ship': 'Entwickeln und bereitstellen',
  'CI/CD and automation': 'CI/CD und Automatisierung',
  'Quality analysis, fixes, and enforcement': 'Qualitätsanalyse, Korrekturen und Durchsetzung von Standards',
  Code: 'Programmieren',
  'AI coding agent for tasks, projects and automated work':
    'KI-Coding-Agent für Aufgaben, Projekte und automatisierte Arbeit',
  'Cloud development environments': 'Cloud-Entwicklungsumgebungen',
  Secure: 'Absichern',
  'Vulnerability detection and remediation': 'Erkennung und Behebung von Sicherheitsrisiken',
  'Secret scanning and leak prevention': 'Geheimnisüberprüfung und Vermeidung von Datenlecks',
  Learn: 'Lernen',
  Certifications: 'Zertifizierungen',
  Build: 'Entwickeln',
  'Customize Copilot': 'Copilot anpassen',
  Explore: 'Erkunden',
  'Trending Repos': 'Beliebte Repositorys',
  Events: 'Veranstaltungen',
  Businesses: 'Unternehmen',
  'By Stage': 'Nach Unternehmensphase',
  'Small & medium teams': 'Kleine und mittlere Teams',
  'By Industry': 'Nach Branche',
  'See all industries': 'Alle Branchen anzeigen',
  'Evaluate GitHub': 'GitHub bewerten',
  'Add-ons': 'Add-Ons',
  'Learn & Connect': 'Lernen und vernetzen',
  'Resource Center': 'Ressourcencenter',
  'Customer Support': 'Support für Kund:innen',
  'About GitHub': 'Über GitHub',
  'Enter your email': 'E-Mail-Adresse eingeben',
  'Not included': 'Nicht enthalten',
  'Pause video': 'Video pausieren',
  'Play video': 'Video abspielen',
  'Pricing plans': 'Preispläne',
  'Select an option': 'Wählen Sie eine Option',
  'Sign up for GitHub': 'Bei GitHub registrieren',
  Country: 'Land',
  'The following fields have errors:': 'Die folgenden Felder enthalten Fehler:',
  'You have the right to refuse the collection and use of your personal information, use of personal information or marketing purposes, and receiving marketing information as set forth above. However, if you refuse, you may not be able to receive the benefits described under Purpose of Collection & Use.':
    'Sie haben das Recht, die Erhebung und Nutzung Ihrer personenbezogenen Daten, die Nutzung personenbezogener Daten für Marketingzwecke und den Empfang von Marketinginformationen wie oben beschrieben abzulehnen. Wenn Sie jedoch ablehnen, können Sie möglicherweise nicht die unter Zweck der Erhebung und Nutzung beschriebenen Vorteile erhalten.',
  'I agree to the collection and use of my personal information (required)*.':
    'Ich stimme der Erhebung und Nutzung meiner personenbezogenen Daten zu (erforderlich)*.',
  'Items of Personal Information to be Collected: {fields}, and any other fields visible on this form.':
    'Zu erhebende personenbezogene Daten: {fields} und alle weiteren in diesem Formular sichtbaren Felder.',
  'Purpose of Collection and Use: GitHub will use the data for the purpose described on this form.':
    'Zweck der Erhebung und Nutzung: GitHub verwendet die Daten für den in diesem Formular beschriebenen Zweck.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting':
    'Aufbewahrungs-/Nutzungszeitraum personenbezogener Daten: So lange wie nötig, um die von Ihnen angeforderten Dienste bereitzustellen.',
  'I agree to receiving marketing information and use of my personal information for marketing purposes (optional).':
    'Ich stimme dem Empfang von Marketinginformationen und der Nutzung meiner personenbezogenen Daten zu Marketingzwecken zu (optional).',
  'Consent to Receive Marketing: The information collected may be used for GitHub for personalized communications, targeted advertising and campaign effectiveness.':
    'Einwilligung zum Empfang von Marketing: Die erhobenen Informationen können von GitHub für personalisierte Kommunikation, gezielte Werbung und Kampagneneffektivität verwendet werden.',
  'Purpose of Collection and Use: To contact you for marketing purposes.':
    'Zweck der Erhebung und Nutzung: Um Sie zu Marketingzwecken zu kontaktieren.',
  'Retention/Use Period of Personal Information: As long as needed to provide the service(s) you are requesting.':
    'Aufbewahrungs-/Nutzungszeitraum personenbezogener Daten: So lange wie nötig, um die von Ihnen angeforderten Dienste bereitzustellen.',
  'Yes please, I’d like GitHub and affiliates to use my information for personalized communications, targeted advertising and campaign effectiveness. See the':
    'Ja, ich möchte, dass GitHub und verbundene Unternehmen meine Informationen für personalisierte Kommunikation, gezielte Werbung und Kampagneneffektivität verwenden. Siehe die',
  'for more details.': 'für weitere Details.',
  'Participation requires transferring your personal data to other countries in which GitHub operates, including the United States. By submitting this form, you agree to the transfer of your data outside of China.':
    'Die Teilnahme erfordert die Übertragung Ihrer personenbezogenen Daten in andere Länder, in denen GitHub tätig ist, einschließlich der Vereinigten Staaten. Durch das Absenden dieses Formulars stimmen Sie der Übertragung Ihrer Daten außerhalb Chinas zu.',
  'I will receive personalized communications and targeted advertising from GitHub and affiliates. See the':
    'Ich werde personalisierte Mitteilungen und gezielte Werbung von GitHub und verbundenen Unternehmen erhalten. Siehe die',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'Ja, ich möchte von GitHub und seinen verbundenen Unternehmen per E-Mail über personalisierte Kommunikation, gezielte Werbung und Kampagneneffektivität informiert werden. Um Ihre Einwilligung zu widerrufen oder Ihre Kontakteinstellungen zu verwalten, besuchen Sie den',
  'Yes, please, I’d like to hear from GitHub and its family of companies via email and phone for personalized communications, targeted advertising, and campaign effectiveness. To withdraw consent or manage your contact preferences, visit the':
    'Ja, ich möchte von GitHub und seinen verbundenen Unternehmen per E-Mail und Telefon über personalisierte Kommunikation, gezielte Werbung und Kampagneneffektivität informiert werden. Um Ihre Einwilligung zu widerrufen oder Ihre Kontakteinstellungen zu verwalten, besuchen Sie den',
  'Promotional Communications Manager': 'Manager für Werbekommunikation',
  'GitHub Privacy Statement': 'GitHub-Datenschutzerklärung',
  '(Updated 02/2024)': '(Aktualisiert im Februar 2024)',
  'first name': 'Vorname',
  'last name': 'Nachname',
  company: 'Unternehmen',
  email: 'E-Mail',
  'This field is required.': 'Dieses Feld ist erforderlich.',
  'Please enter a valid value.': 'Bitte geben Sie einen gültigen Wert ein.',
  'Please enter a valid work email address.': 'Bitte geben Sie eine gültige geschäftliche E-Mail-Adresse ein.',
  'The email is from a personal email provider.': 'Die E-Mail stammt von einem privaten E-Mail-Anbieter.',
  'Please enter a valid email address.': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  'Please enter a valid phone number.': 'Bitte geben Sie eine gültige Telefonnummer ein.',
  'Please select your country/region': 'Bitte wählen Sie Ihr Land/Ihre Region.',
  'Please complete the CAPTCHA.': 'Bitte füllen Sie das CAPTCHA aus.',
  'Choose your country/region': 'Wählen Sie Ihr Land/Ihre Region.',
  Included: 'Enthalten',
  Refresh: 'Aktualisieren',
  Unlimited: 'Unbegrenzt',
  'Learn more': 'Mehr erfahren',
  'Dev Days are here! Join an in-person event near you to learn more about the GitHub Copilot app and Copilot CLI with your community.':
    'Die Dev Days sind da! Registriere dich, um vor Ort in deiner Nähe eine Veranstaltung zu organisieren und deiner Community die GitHub Copilot App und die GitHub Copilot CLI näherzubringen.',
  'Sort by:': 'Sortieren nach:',
  'Selecting a sort option will reload the page.': 'Die Auswahl einer Sortieroption lädt die Seite neu.',
  'Sort options': 'Sortieroptionen',
  Sort: 'Sortieren',
  Newest: 'Neueste',
  Oldest: 'Älteste',
  Whitepaper: 'Whitepaper',
  'Content Type': 'Inhaltstyp',
  Category: 'Kategorie',
  Whitepapers: 'Whitepapers',
  Ebooks: 'E-Books',
  AI: 'KI',
  Cloud: 'Cloud',
  DevOps: 'DevOps',
  'GitHub Actions': 'GitHub Actions',
  'GitHub Advanced Security': 'GitHub Advanced Security',
  'GitHub Enterprise': 'GitHub Enterprise',
  Innersource: 'Innersource',
  'Open Source': 'Open Source',
  Security: 'Sicherheit',
  'Software Development': 'Softwareentwicklung',
  'Explore other resources': 'Weitere Ressourcen entdecken',
  Share: 'Teilen',
  'Ebooks & Whitepapers': 'E-Books und Whitepapers',
  Tags: 'Tags',
  Ebook: 'E-Book',
  Platform: 'Plattform',
  'AI CODE CREATION': 'CODEERSTELLUNG MIT KI',
  'GitHub Copilot': 'GitHub Copilot',
  'Write better code with AI': 'Mit KI besseren Code schreiben',
  'GitHub Copilot app': 'GitHub Copilot-App',
  'Direct agents from issue to merge': 'Direkt-Agenten vom Issue zum Merge',
  'GitHub Spark': 'GitHub Spark',
  'Build and deploy intelligent apps': 'Intelligente Apps entwickeln und bereitstellen',
  'GitHub Models': 'GitHub Models',
  'Manage and compare prompts': 'Prompts verwalten und vergleichen',
  'MCP Registry (New)': 'MCP-Registry (neu)',
  'Integrate external tools': 'Externe Tools integrieren',
  'View all features': 'Alle Funktionen anzeigen',
  'DEVELOPER WORKFLOWS': 'ENTWICKLUNGS-WORKFLOWS',
  Actions: 'GitHub Actions',
  'Automate any workflow': 'Workflows automatisieren',
  Codespaces: 'Codespaces',
  'Instant dev environments': 'Umgebungen zur sofortigen Entwicklung',
  Issues: 'Issues',
  'Plan and track work': 'Arbeit planen und verfolgen',
  'Code review': 'Code Review',
  'Manage code changes': 'Codeänderungen verwalten',
  'APPLICATION SECURITY': 'ANWENDUNGSSICHERHEIT',
  'Find and fix vulnerabilities': 'Schwachstellen suchen und beheben',
  'Code Security': 'GitHub Code Security',
  'Secure your code as you build': 'Code beim Entwickeln sichern',
  'Secret Protection': 'GitHub Secret Protection',
  'Stop leaks before they start': 'Leaks von vornherein verhindern',
  EXPLORE: 'ERKUNDEN',
  'Why GitHub': 'Was für GitHub spricht',
  Documentation: 'Dokumentation',
  Blog: 'Blog',
  Changelog: 'Changelog',
  'GitHub Marketplace': 'GitHub Marketplace',
  Solutions: 'Lösungen',
  'BY COMPANY SIZE': 'NACH FIRMENGRÖSSE',
  Enterprises: 'Großunternehmen',
  'Small and medium teams': 'Kleine und mittlere Teams',
  Startups: 'Start-ups',
  Nonprofits: 'Gemeinnützige Organisationen',
  'View all solutions': 'Alle Lösungen anzeigen',
  'BY USE CASE': 'NACH ANWENDUNGSFALL',
  'App modernization': 'App-Modernisierung',
  DevSecOps: 'DevSecOps',
  'View all use cases': 'Alle Anwendungsfälle anzeigen',
  'BY INDUSTRY': 'NACH BRANCHE',
  Healthcare: 'Gesundheitswesen',
  'Financial services': 'Finanzdienstleistungen',
  Manufacturing: 'Fertigung',
  Government: 'Öffentliche Verwaltung',
  'View all industries': 'Alle Branchen anzeigen',
  Resources: 'Ressourcen',
  'EXPLORE BY TOPIC': 'NACH THEMA ERKUNDEN',
  'Software development': 'Softwareentwicklung',
  'View all topics': 'Alle Themen anzeigen',
  'EXPLORE BY TYPE': 'NACH TYP ERKUNDEN',
  'Customer stories': 'Referenzen',
  'Events & webinars': 'Veranstaltungen und Webinare',
  'Ebooks & reports': 'E-Books und Berichte',
  'Business insights': 'Geschäftliche Einblicke',
  'GitHub Skills': 'GitHub Skills',
  'SUPPORT & SERVICES': 'SUPPORT UND DIENSTE',
  Customer: 'Kundensupport',
  'Customer support': 'Support für Kund:innen',
  'Community forum': 'Community-Forum',
  'Trust Center': 'Trust Center',
  Partners: 'Partner:innen',
  COMMUNITY: 'COMMUNITY',
  'GitHub Sponsors': 'GitHub Sponsors',
  'Fund open source developers': 'Open-Source-Entwickler:innen finanzieren',
  'The ReadME Project': 'Das ReadME-Projekt',
  'GitHub community articles': 'Artikel der GitHub Community',
  'COMMUNITY PROGRAMS': 'COMMUNITY-PROGRAMME',
  'Security Lab': 'Security Lab',
  'Maintainer Community': 'Maintainer Community',
  Accelerator: 'Accelerator',
  'Archive Program': 'Archivprogramm',
  REPOSITORIES: 'REPOSITORYS',
  Topics: 'Themen',
  Trending: 'Häufig aufgerufen',
  Collections: 'Sammlungen',
  Enterprise: 'Unternehmen',
  'ENTERPRISE SOLUTIONS': 'UNTERNEHMENSLÖSUNGEN',
  'Enterprise platform': 'Unternehmensplattform',
  'AI-powered developer platform': 'KI-gestützte Entwicklungsplattform',
  'AVAILABLE ADD-ONS': 'VERFÜGBARE ADD-ONS',
  'Enterprise-grade application security': 'Unternehmenstaugliche Anwendungssicherheit',
  'Copilot for Business': 'GitHub Copilot Business',
  'Enterprise-grade AI features': 'Unternehmenstaugliche KI-Funktionen',
  'Premium Support': 'Premium-Support',
  'Enterprise-grade 24/7 support': 'Unternehmenstauglicher Support rund um die Uhr',
  New: 'Neu',
  Select: 'Auswählen',
  'Install with script': 'Mit Skript installieren',
  'Install with npm': 'Mit npm installieren',
  'Install with Homebrew': 'Mit Homebrew installieren',
  'Install with WinGet': 'Mit WinGet installieren',
  Copy: 'Kopieren',
  'Copy installation command': 'Installationsbefehl kopieren',
  'Copied to clipboard': 'In die Zwischenablage kopiert',
  'Send me a download link': 'Downloadlink an mich senden',
  'Download link copied.': 'Downloadlink kopiert.',
  Copied: 'Kopiert',
  'Copy download link': 'Downloadlink kopieren',
  "This browser doesn't support sharing. Copy the download link instead.":
    'Dieser Browser unterstützt das Teilen nicht. Kopieren Sie stattdessen den Downloadlink.',
  "We couldn't share the download link. Copy it instead.":
    'Der Downloadlink konnte nicht geteilt werden. Kopieren Sie ihn stattdessen.',
  "This browser doesn't support copying. Copy the current page URL from the address bar instead.":
    'Dieser Browser unterstützt das Kopieren nicht. Kopieren Sie stattdessen die URL der aktuellen Seite aus der Adressleiste.',
  "We couldn't copy the download link. Copy the current page URL from the address bar instead.":
    'Der Downloadlink konnte nicht kopiert werden. Kopieren Sie stattdessen die URL der aktuellen Seite aus der Adressleiste.',
  'The download link is invalid. Please try again later.':
    'Der Downloadlink ist ungültig. Versuchen Sie es später erneut.',
  "We couldn't copy the download link. Copy the link below instead.":
    'Der Downloadlink konnte nicht kopiert werden. Kopieren Sie stattdessen den unten stehenden Link.',
  "This browser doesn't support copying. Copy the link below instead.":
    'Dieser Browser unterstützt das Kopieren nicht. Kopieren Sie stattdessen den unten stehenden Link.',
  'Select install method': 'Installationsmethode auswählen',
  'Get Copilot CLI': 'Copilot CLI herunterladen',
  'Read the documentation.': 'Lesen Sie die Dokumentation.',
  'Included in Copilot Free, Pro, Pro+, Business, and Enterprise subscriptions.':
    'Enthalten in Copilot Free, Pro, Pro+, Business und Enterprise-Abonnements.',
  'Included in Copilot Free, Pro, Pro+, Max, Business, and Enterprise subscriptions.':
    'Enthalten in Copilot Free, Pro, Pro+, Max, Business und Enterprise-Abonnements.',
  'Available with Copilot Free, Pro, Pro+, Business, and Enterprise.':
    'Verfügbar mit Copilot Free, Pro, Pro+, Business und Enterprise.',
  'Available with Copilot Free, Pro, Pro+, Max, Business, and Enterprise.':
    'Verfügbar mit Copilot Free, Pro, Pro+, Max, Business und Enterprise.',
  'View all resources': 'Alle Ressourcen anzeigen',
  'Enterprise-grade security features': 'Sicherheitsfunktionen auf Unternehmensniveau',
  Pricing: 'Preise',
  'Select country for phone number. Currently selected:': 'Land für Telefonnummer auswählen. Aktuell ausgewählt:',
  'Search countries': 'Länder suchen',
  'Search countries...': 'Länder suchen...',
  Countries: 'Länder',
  'No countries found': 'Keine Länder gefunden',
  '{count} result available': '{count} Ergebnis verfügbar',
  '{count} results available': '{count} Ergebnisse verfügbar',
  'Get the ebook': 'E-Book jetzt herunterladen',
  'Get the analysis': 'Analyse jetzt herunterladen',

  // Marketing navigation and footer
  Products: 'Produkte',
  Copilot: 'Copilot',
  'All Features': 'Alle Funktionen',
  Developers: 'Entwickler:innen',
  'GitHub CLI': 'GitHub CLI',
  'GitHub Desktop': 'GitHub Desktop',
  'GitHub Mobile': 'GitHub Mobile',
  Integrations: 'Integrationen',
  'MCP Registry': 'MCP-Registrierung',
  Training: 'Training',
  'Build with Copilot': 'Mit Github Copilot entwickeln',
  'GitHub Status': 'GitHub Status',

  // Marketing footer
  Subscribe: 'Abonnieren',
  Ecosystem: 'Ökosystem',
  Support: 'Support',
  Company: 'Unternehmen',
  Features: 'Merkmale',
  Team: 'GitHub Team',
  Roadmap: 'Roadmap',
  'Compare GitHub': 'GitHub vergleichen',
  'Developer API': 'API für Entwickler:innen',
  Education: 'Bildung',
  Docs: 'Dokumente',
  'Community Forum': 'Community-Forum',
  'Professional Services': 'Fachliche Dienstleistungen',
  Skills: 'Fähigkeiten',
  Status: 'Status',
  'Contact GitHub': 'Kontakt mit GitHub aufnehmen',
  About: 'Über uns',
  Careers: 'Karriere',
  Newsroom: 'Newsroom',
  Inclusion: 'Inklusion',
  'Social Impact': 'Soziale Auswirkungen',
  Shop: 'Shop',
  'What is Git?': 'Was ist eigentlich Git?',
  Sitemap: 'Sitemap',
  Terms: 'Bedingungen',
  Privacy: 'Datenschutz',
  'Manage cookies': 'Cookies verwalten',
  'Do not share my personal information': 'Meine personenbezogenen Daten nicht teilen',

  // Marketing footer — newsletter heading/description reuse legacy copy (pending loc review)
  'The developer newsletter': 'Abonniere unseren Newsletter für Entwickler:innen',
  'Get tips, technical guides, and best practices. Twice a month. Right in your inbox.':
    'Erhalte Tipps, technische Anleitungen und bewährte Methoden. Zweimal monatlich. Direkt in deinen Posteingang.',
  'Customer Stories': 'Referenzen',

  // Marketing footer — a11y/nav and social labels (drafted, pending loc verification)
  'Go to GitHub homepage': 'Zur GitHub-Startseite',
  'Site-wide Links': 'Links für die gesamte Website',
  'Legal and Resource Links': 'Rechtliche Hinweise und Ressourcen',
  "GitHub's Social Media Links": 'GitHubs Social-Media-Links',
  'Select language': 'Sprache auswählen',
  'GitHub on LinkedIn': 'GitHub auf LinkedIn',
  'GitHub on Instagram': 'GitHub auf Instagram',
  'GitHub on YouTube': 'GitHub auf YouTube',
  'GitHub on X': 'GitHub auf X',
  'GitHub on TikTok': 'GitHub auf TikTok',
  'GitHub on Twitch': 'GitHub auf Twitch',
  'GitHub’s organization on GitHub': 'GitHubs Organisation auf GitHub',

  // Article page table of contents
  'Table of contents': 'Inhaltsverzeichnis',
  'Open table of contents': 'Inhaltsverzeichnis öffnen',
  'Close table of contents': 'Inhaltsverzeichnis schließen',
  'Code Quality': 'Code Quality',
  'Enforce quality at merge': 'Qualität beim Merge durchsetzen',
  // EmailCaptureForm
  'Email address': 'E-Mail-Adresse',
  'Email capture form': 'Formular zur E-Mail-Erfassung',
  'Submitting your email address…': 'E-Mail-Adresse wird übermittelt …',
  'Thanks! Your email address has been submitted.': 'Vielen Dank! Ihre E-Mail-Adresse wurde übermittelt.',
  'Something went wrong. Please try again.': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  'More information about {feature}': 'Weitere Informationen zu {feature}',
  'More information about this feature': 'Weitere Informationen zu dieser Funktion',
  // Add more translations here
}
